import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { toTextDateString, toTimeString } from "../../../utils/date";
import { isSameDate } from "../../../designSystem/formField/DateStartEndTimeFields";
import { AmorgMenu, AmorgMenuProps } from "../../../designSystem/amorgMenu";
import { H2, H3 } from "../../../designSystem/typography/Heading";
import { iconName } from "../../../designSystem/icons/Icons";
import { Pill } from "../../../designSystem/pill/Pill";
import { CardButton } from "../../../designSystem/CardButton";

type ActivityListingViewProps = {
    title:string,
    start:Date,
    end:Date,
    href:string,
    menuProps:AmorgMenuProps,
    onClick?: () => void
}


export function ActivityListingView(props:ActivityListingViewProps):JSX.Element
{

    function handleOnClick(){
        document.location=props.href;
    }

    return (
        
        <CardButton onClick={ handleOnClick }>
            <Flex flexDirection="column" gap={24}>
                <Flex flexDirection="column">
                    <H2>{props.title}</H2>
                    <H3>
                        
                    {!isSameDate(props.start, props.end) ? 
                        toTextDateString(props.start) + " kl. " + toTimeString(props.start) + " - " + toTextDateString(props.end) + " kl. " + toTimeString(props.end) 
                        : 
                        toTextDateString(props.start) + " kl. " + toTimeString(props.start) + " - " + toTimeString(props.end)
                    }
                    </H3>
                </Flex>
                <AmorgMenu {...props.menuProps} />
            </Flex>
        </CardButton>
    );
}


type ActivityListingView2Props = {
    title:string,
    start:Date,
    end:Date,
    pills?:string[],
    menuItems:{ icon:iconName, status:'pending' | 'warning' | 'success', primaryText:string, secondaryText?:string }[],
    onClick?: () => void
}
export function ActivityListingView2(props:ActivityListingView2Props):JSX.Element
{
    return (
        <CardButton onClick={ props.onClick }>
            <Flex flexDirection="column" gap={24}>
                <Flex flexDirection="column" gap={8}>
                    <H2>{props.title}</H2>
                    <H3>
                        {!isSameDate(props.start, props.end) ?
                            toTextDateString(props.start) + " kl. " + toTimeString(props.start) + " - " + toTextDateString(props.end) + " kl. " + toTimeString(props.end)
                            :
                            toTextDateString(props.start) + " kl. " + toTimeString(props.start) + " - " + toTimeString(props.end)
                        }
                    </H3>
                    {props.pills && props.pills.length > 0 &&
                        <Flex gap={8}>
                            {props.pills.map((pill, index) =>
                                <Pill key={index} identifier={pill}>
                                    {pill}
                                </Pill>
                            )}
                        </Flex>
                    }
                </Flex>
                <AmorgMenu content={
                    props.menuItems.map((menuItem) => {

                        const styleVariant = menuItem.status === 'warning' ? 'destructive' : 'default';
                        
                        let icon:iconName = menuItem.icon;
                        if(menuItem.icon)
                            icon = menuItem.icon;
                        else {
                            if(menuItem.status === 'warning')
                                icon = 'warning'
                            else if(menuItem.status === 'pending')
                                icon = 'actions_close';
                        }

                        if(menuItem.icon)
                            icon = menuItem.icon;


                        if(menuItem.secondaryText) {
                            return {
                                type: 'leadingTrailingContent',
                                styleVariant: styleVariant,
                                leadingContent: { type: 'icon', iconName:icon },
                                primaryContent: { type: 'text', text: menuItem.primaryText },
                                trailingContent: { type: 'text', text: menuItem.secondaryText }
                            };
                        }
                        else {
                            return {
                                type: 'leadingContent',
                                styleVariant: styleVariant,
                                leadingContent: { type: 'icon', iconName:icon },
                                primaryContent: { type: 'text', text: menuItem.primaryText }
                            };
                        }
                    })
                } />
            </Flex>
        </CardButton>
    );
}